import { useUserQuery } from "../common/lib/fetch";
import { QueryOptions } from "../common/lib/fetch/useQuery";
import { useUser } from "../userAccess/useUser";

export enum StagedOrderStep {
    CheckIn = "CheckIn",
    Tare = "Tare",
    BayDirections = "BayDirections",
    Gross = "Gross",
    Signature = "Signature",
    TicketInstructions = "TicketInstructions",
    RejectedGross = "RejectedGross",
}

export interface StagedOrderDetails {
  id: string;
  orderNumber: string;
  orderNumbers: string[];
  userEmail: string;
  step: StagedOrderStep;
  transport: string;
  customers: string[];
  products: string[];
  availableToRequest: number;
  bay: string;
  destinations: string[];
  createdAt: string;
  manuallyLoaded: boolean;
}

export const useGetStagedOrders = (options?: QueryOptions<StagedOrderDetails[]>) => {
  const user = useUser();

  return useUserQuery<StagedOrderDetails[]>({
    path: `/api/sites/${user.selectedSite?.id}/stagedOrders`,
  }, options);
}
